import type { IProduct } from '@/services/models/Product';
import { useMemo } from 'react';
import ProductTileVM, {
  type IAppliedRefinements
} from '../view-models/ProductTileVM';

/**
 * Creates a product tile view model from a given {@link IProduct}.
 * @param product - The product to create a view model from.
 * @param appliedRefinements - The applied refinements by the user.
 * @returns A product view model.
 */
export const useProductTile = (
  product: IProduct,
  appliedRefinements: IAppliedRefinements
): ProductTileVM =>
  useMemo(() => {
    return new ProductTileVM(product, appliedRefinements);
  }, [product, appliedRefinements]);
